const styles = {
  wrapper: {
    // display: 'grid',
    // gridGap: '10px',
    // gridTemplateColumns: '1fr 1.5fr 1.5fr',
    // gridTemplateAreas:
    //   '"navbar navbar navbar" "header  header  header"' +
    //   '"kpis  kpis  kpis" "sidebar content content" "kpis2 kpis2 kpis2" ' +
    //   '"sidebarcharts contentcharts contentcharts" "footer  footer  footer"',
    backgroundColor: '#fff',
    color: '#444',
  },
  header: {
    gridArea: 'header',
    padding: '5px 15px',
    fontSize: 24,
    fontFamily: 'League Gothic',
  },
  nav: {
    position: 'relative',
    '& a': {
      '&:hover': {
        color: '#7F1431',
      },
    },
  },
  liveResults: {
    backgroundColor: 'red',
    color: 'white',
    padding: '1px 4px',
    fontFamily: 'League Gothic',
    fontSize: '12px',
    position: 'absolute',
    top: '-10px',
    right: '-25px',
    textTransform: 'uppercase',
  },
  currenttournamet: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: '#F4F5F0',
  },
  // kpis: {
  //   gridArea: 'kpis',
  //   padding: 10,
  //   fontSize: 12,
  //   display: 'flex',
  //   flexWrap: 'wrap',
  //   justifyContent: 'space-between',
  //   backgroundColor: 'rgb(244, 245, 240)',
  // },

  // kpi: {
  //   flexGrow: 1,
  //   padding: '2em',
  // },
  // kpititle: {
  //   textAlign: 'center',
  //   fontSize: 16,
  //   textTransform: 'uppercase',
  //   color: '#787878',
  // },
  // kpikpi: {
  //   fontSize: 30,
  //   // color: '#63AC1F',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   height: '100%',
  //   maxHeight: 55,
  // },
  // kpinum: {
  //   fontSize: 62,
  //   // color: '#63AC1F',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   height: '100%',
  //   maxHeight: 55,
  // },
  // kpisuffix: {
  //   fontSize: 10,
  //   maxWidth: 100,
  //   marginLeft: 10,
  // },
  kpis: {
    padding: '20px 10px',
    fontSize: 12,
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    backgroundColor: '#F4F5F0',
  },

  kpi: {
    flexGrow: 1,
    padding: '1.5em 1em',
    margin: '.5em',
    backgroundColor: '#FFFFFF',
    border: '1px solid #7F1431',
    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    width: '19%',
    boxShadow: '#7F1431 8px 8px 0px -3px',
    textAlign: 'center',
    // background-image: url(assets/images/france.png);
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'right',
  },
  kpititle: {
    textAlign: 'center',
    fontSize: '2em',
    textTransform: 'uppercase',
    color: '#7F1431',
    fontFamily: 'League Gothic',
  },
  kpikpi: {
    fontSize: '3.5em',
    // color: '#63AC1F',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '100%',
    // maxHeight: 55,
  },
  kpinum: {
    fontSize: 62,
    // color: '#63AC1F',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // gap: '10px',
    // height: '100%',
    // maxHeight: 55,
    // paddingTop: '0.5em',
  },
  kpisuffix: {
    fontSize: 12,
    maxWidth: 220,
    textAlign: 'center',
    // marginLeft: 10,
  },
  footer: {
    gridArea: 'footer',
    padding: 50,
  },
  content: {
    gridArea: 'content',
    position: 'relative',
    padding: 15,
    fontFamily: 'Roboto !important',
    overflow: 'auto',
    flexGrow: 1,
    flexBasis: 470,
    backgroundColor: '#fff',
    marginBottom: 10,
  },

  head: {
    fontSize: 24,
    paddingBottom: 10,
    color: '#7F1431',
    fontFamily: 'League Gothic',
  },
  groups: {
    gridArea: 'content',
    position: 'relative',
    // padding: 10,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '20px',
  },
  tablegroups: {
    fontSize: 13,
    borderCollapse: 'collapse',
    borderSpacing: '0',
    width: '100%',
  },
  sidebar: {
    gridArea: 'sidebar',
    padding: 15,
    flexGrow: 1,
    flexBasis: '1',
    backgroundColor: '#fff',
    marginBottom: 10,
    // borderRight: '10px solid #F4F5F0',
    // backgroundColor: '#F4F5F0',

  },
  contentcol: {
    display: 'grid',
    gridTemplateRows: '0fr 1fr 0fr 1fr',
    gridRowGap: '10px',
  },
  chart: {
    height: 200,
  },
  thead: {
    // color: '#63AC1F',
    borderBotom: '1px solid #dedede',
    textTransform: 'uppercase',
    // fontWeight: '600',
  },
  th: {
    fontWeight: '500',
  },
  tbody: {
    borderTop: '1px solid lightgray',
  },
  teamname: {
    minWidth: 110,
  },
  in: {
    color: '#787878',
  },
  out: {
    color: '#ccc',
  },

  // bracket

  bracket: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'auto',
  },
  bracketcontent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 2fr 1fr 1fr 1fr',
    gridColumnGap: '10px',
    // justifyContent: 'stretch',
    fontFamily: 'Roboto',
    minHeight: '380px',
    fontSize: 13,
    // fontWeight: '600',
    color: '#9C9BA4',
  },
  bracketcontentRN: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 2fr 1fr 1fr 1fr',
    gridColumnGap: '10px',
    justifyContent: 'stretch',
    fontFamily: 'Roboto',
    // fontSize: '12px',
    // fontWeight: '600',
    fontSize: 11,
    color: '#9C9BA4',
    marginBottom: 20,
  },
  spacer3: {
    flexGrow: '2.23',
  },

  eighths_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: '1',
    textAlign: 'right',
  },
  eighths_left_top: {
    padding: '0 10px',
    flexGrow: '1',
  },
  eighths_left_bottom: {
    padding: '0 10px',
    flexGrow: '1',
  },
  quarters_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    margin: '26px 0',
    textAlign: 'right',
    flexGrow: '1',
  },
  quarters_leftRN: {
    // display: 'flex',
    textAlign: 'right',
    flexGrow: '1',
  },
  semis_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'right',
    flexGrow: '1',
  },
  match_left: {
    borderRight: '1px solid lightgray',
    padding: '0 10px 0 0',
  },
  finals: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 10px',
    flexGrow: '0.25',
  },
  final: {
    // display: 'flex',
    // fontSize: '16px',
    fontWeight: '700',
    flexGrow: '1',
    color: '#9C9BA4',
    width: '100%',
    marginTop: 140,
    textAlign: 'center',
  },
  thirdfourth: {
  // marginTop: '60px',
    color: '#9C9BA4',
    flexGrow: '1',
    textAlign: 'center',
  },
  match_right: {
    borderLeft: '1px solid lightgray',
    padding: '0 0 0 10px',
  },
  semis_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexGrow: '1',
  },
  quarters_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    margin: '26px 0',
    flexGrow: '1',
  },
  quarters_rightRN: {
    display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'space-around',
    // alignItems: 'stretch',
    // margin: '26px 0',
    flexGrow: '1',
  },
  eighths_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    flexGrow: '1',
  },
  eighths_right_top: {
    padding: '0 10px',
    flexGrow: '1',
  },
  eighths_right_bottom: {
    padding: '0 10px',
    flexGrow: '1',
  },
  rightside: {
    display: 'flex',
    flexGrow: '0.375',
    textAlign: 'right',
  },
  game: {
    whiteSpace: 'nowrap',
    fontSize: 12,
    color: '#666',
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
};

export default styles;
